import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Destaques, DestaquesSend } from '../_model/Destaques';
import { Media } from '../_model/media';
import { DestaquesService } from '../_services/destaques.service';
import { faTrash, faEdit } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-insertDestaques',
    templateUrl: './insertDestaques.component.html',
    styleUrls: ['./insertDestaques.component.less'],
    standalone: false
})
export class InsertDestaquesComponent implements OnInit {

  faTrash = faTrash;
  faEdit = faEdit;

  constructor(private desc: DestaquesService) { }

  model: DestaquesSend = new DestaquesSend();

  apiUrl: string = environment.apiUrl;

  list: Destaques[] = [];

  ngOnInit() {
    
    this.model.userId = localStorage.getItem("userId");
    this.desc.list().subscribe((data: any[]) => {
      data.forEach(el => {
        this.list.push(new Destaques(el));
      });
    });
  }

  clear() {
    this.model = new DestaquesSend();
    this.model.userId = localStorage.getItem("userId");
    this.model.id = -1;
  }

  send() {
    if(this.model.nome == '') {
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>Falta o nome do Destaque</h1>",
        icon: 'warning',
        customClass: {
          popup: 'card-border-gold',
        }
      });
    }else if(this.model.subnome == ''){
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>Falta o subnome do Destaque</h1>",
        icon: 'warning',
        customClass: {
          popup: 'card-border-gold',
        }
      });
    }else if((!this.model.typeMedia && this.model.media1.length == 0) || (this.model.typeMedia && this.model.media2 == '')){
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>Falta imagem / video do Destaque</h1>",
        icon: 'warning',
        customClass: {
          popup: 'card-border-gold',
        }
      });
    }else{
      this.desc.send(this.model).subscribe(() => {
        this.list = [];
        this.desc.list().subscribe((data: any[]) => {
          data.forEach(el => {
            this.list.push(new Destaques(el));
          });
        });
        if(this.model.id > 0) {
          Swal.fire({
            title: "<h1 class='textColor harvest-gold base'>Destaque actualizado com sucesso</h1>",
            icon: 'success',
            position: "top-end",
            timer: 1500,
            showConfirmButton: false,
            customClass: {
              popup: 'card-border-gold',
            }
          });
        }else{
          Swal.fire({
            title: "<h1 class='textColor harvest-gold base'>Destaque inserido com sucesso</h1>",
            icon: 'success',
            position: "top-end",
            timer: 1500,
            showConfirmButton: false,
            customClass: {
              popup: 'card-border-gold',
            }
          });
        }
        this.clear();
      });
    }
  }

  bind(item: Destaques) {
    this.model.id = item.id;
    this.model.nome = item.nome;
    this.model.subnome = item.subnome;
    this.model.body = item.body;
    this.model.typeMedia = item.typeMedia;
    this.model.master = item.master;
    this.model.link = item.link;
    if(item.typeMedia){
      this.model.media2 = item.media;
    }else{
      this.desc.getMediaRaw(item.id).subscribe((data: any[]) => {
        this.model.media1 = [];
        data.forEach(el => {
          this.model.media1.push(new Media(el));
        });
        console.log(this.model.media1);
      })
    }
    this.model.activo = item.activo;
    this.model.userId = localStorage.getItem("userId");
  }

  delete(item: Destaques) {
    Swal.fire({
      title: "Tem a certeza que pretende eliminar a produto?",
      text: "Se continuar com esta ação irá eliminar "+item.nome+" da lista de destaques",
      icon: 'warning',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      showCancelButton: true,
      customClass: {
        confirmButton: "btn red base",
        cancelButton: "btn green base"
      }
    }).then((result) => {
      if(result.isConfirmed) {
        Swal.fire({
          title: "Produto Eliminado com sucesso",
          text: "O produto "+item.nome+" foi eliminado da lista de destaques",
          icon: 'success'
        });
        this.desc.delete(item.id, localStorage.getItem("userId")).subscribe((data: any) => {
          this.clear();
          
          this.desc.list().subscribe((data: any) => {
            this.list = [];
            data.forEach(el => {
              this.list.push(new Destaques(el));
            });
          });
        });
      }
    });
  }

}
